<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><strong>Acknowledgments</strong></h2>
<p class="indent">Many people have inspired me and encouraged me to write: parents, teachers, family, friends, colleagues, and creative collaborators. I especially thank these authors who generously shared their personal experience, insight, and resources: Daniel Blum, Connie Johnson Hambley, Jeff Miller, Satin Russell and Ric Wasley. I learned a tremendous amount from developmental editor, Karen Aroian, who reviewed an early draft of <em>Tory Roof</em>. I deeply appreciate the enthusiasm, vigilance and constructive feedback offered by my beta readers, Dagny Goldberg Baker and Gail Gamble. To my husband, Jon, I say thank you for giving me the time and space to write, for tolerating my endless musings, and for providing the professional expertise in making my content presentable. Lastly, I am sincerely indebted to Michael Gordon for his friendship, representation, guidance, and industry connections. For <em>Tory Roof</em> especially, I pay respect to the patriots and unsung heroes who paved the way.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?27027d94